import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { MaterialBoolControl } from 'console/shared/components/fields';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { set_slow_mode_action } from '../redux/action';
export const FirmwareFooter = (props) => {
    const { title = 'Обновить прошивку', disabled = false, is_loading = false, onUpdateClick, } = props;
    const slow_mode = useAppSelector((state) => state.upgrade_soft.slow_mode);
    const setSlowMode = useAction(set_slow_mode_action);
    const _onUpdateClick = useCallback((e) => {
        onUpdateClick();
    }, [onUpdateClick]);
    return (_jsxs(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, children: [_jsx(MaterialBoolControl, { value: slow_mode, label: "\u041C\u0435\u0434\u043B\u0435\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C", onChange: setSlowMode, help_id: "firmware__slow_mode" }), _jsx(LoadingButton, { loading: is_loading, disabled: disabled, onClick: _onUpdateClick, variant: "contained", color: "primary", children: title })] }));
};
